import { jsx as _jsx, Fragment as _Fragment } from 'react/jsx-runtime.js';
import { useAppSelector } from '../../redux/hooks.js';
import { isEmailSentSelector } from './resetPasswordSlice.js';
import { ResetPassword } from './ResetPassword/index.js';
import { ResetPasswordSuccess } from './ResetPasswordSuccess/index.js';
export function ResetPasswordForm() {
    const resetPasswordEmailSent = useAppSelector(isEmailSentSelector);
    return (_jsx(_Fragment, { children: resetPasswordEmailSent === false ? (_jsx(ResetPassword, {})) : (_jsx(ResetPasswordSuccess, {})) }));
}
//# sourceMappingURL=ResetPasswordForm.js.map